import { Select } from "radix-ui";
import SelectItem from "../../../atoms/controls/select/SelectItem";
import ChevronDownIcon from "../../../atoms/images/ChevronDownIcon";
import { cn } from "../../../../helpers/utils";

export default function DropdownSelect({
  value,
  onChange,
  options = [],
  className,
  disabled,
}) {
  return (
    <div className={cn("inline-block w-full", className)}>
      <Select.Root value={value} onValueChange={onChange} disabled={disabled}>
        <Select.Trigger
          className={cn(
            "flex w-full h-[50px] items-center justify-between rounded-md border border-gray-300 bg-white",
            "px-3 py-2 text-sm text-gray-700 focus:outline-none",
            "disabled:opacity-70 disabled:cursor-not-allowed"
          )}
        >
          <Select.Value />
          <Select.Icon>
            <ChevronDownIcon size={9} />
          </Select.Icon>
        </Select.Trigger>
        <Select.Portal>
          <Select.Content
            position="item-aligned"
            sideOffset={4}
            className="z-50 max-h-60 overflow-auto rounded-md border border-gray-200 bg-white shadow-lg"
          >
            <Select.Viewport className="p-1">
              {options.map((option, index) => (
                <SelectItem key={index} value={option.value} className="w-full">
                  {option.label}
                </SelectItem>
              ))}
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
    </div>
  );
}
